"use client";

import {
	InputGroup,
	InputGroupAddon,
	InputGroupButton,
	InputGroupInput,
} from "@ui/components/input-group";
import { EyeIcon, EyeOffIcon } from "lucide-react";
import { useState } from "react";

type PasswordInputProps = {
	value: string;
	onChange: (value: string) => void;
} & Omit<React.ComponentProps<"input">, "value" | "onChange" | "type">;

/** Password field with a show/hide toggle that keeps focus in the input. */
export function PasswordInput({
	value,
	onChange,
	className,
	...rest
}: PasswordInputProps) {
	const [visible, setVisible] = useState(false);

	return (
		<InputGroup className={className}>
			<InputGroupInput
				type={visible ? "text" : "password"}
				value={value}
				onChange={(event) => onChange(event.target.value)}
				{...rest}
			/>
			<InputGroupAddon align="inline-end">
				<InputGroupButton
					size="icon-xs"
					aria-label={visible ? "Hide password" : "Show password"}
					aria-pressed={visible}
					onClick={() => setVisible((current) => !current)}
				>
					{visible ? <EyeOffIcon /> : <EyeIcon />}
				</InputGroupButton>
			</InputGroupAddon>
		</InputGroup>
	);
}
